import axios from "axios";

const baseOpenAPI = "https://homemate2.orvibo.com";

/**
 * @name 查询设备列表
 * @param {token} token
 * @param {m} queryDevice
 * 一个设备信息:
 String uid;
 String deviceId;
 String irDeviceId;
 String deviceName;
 int deviceType;
 String model;
 String picUrl;
 String roomId;
 String roomName;
 */
export const queryDeviceList = params => {
  return axios.get(`${baseOpenAPI}/device?m=queryDevice`, { params: params }).then(res => res.data);
};

/*  查询设备信息
 * @param {token} token
 * @param {deviceId} deviceId
* */
export const queryDeviceInfo = params => {
  return axios.get(`${baseOpenAPI}/device?m=deviceDetail`, { params: params }).then(res => res.data);
};

/**
 * @name 绑定设备
 * @param {m} bindDevice
 * @param {token} token
 * @param {uid} 设备UID
 */

export const bindDevice = params => {
  return axios.get(`${baseOpenAPI}/device?m=bindDevice`, { params: params }).then(res => res.data);
};

/**
 * @name 绑定设备，只有在设备在线的情况下才会返回正确结果
 * @param {m} bindDevice
 * @param {token} token
 * @param {uid} 设备UID
 */

export const bindDeviceOnline = params => {
  return axios.get(`${baseOpenAPI}/device?m=bindDeviceOnline`, { params: params }).then(res => res.data);
};

/**
 * @name 解绑设备，小方只能解绑不能删除
 * @param {m}  unbindDevice
 * @param {token} token
 * @param {uid} 设备UID
 */
export const unbindDevice = params => {
  return axios.get(`${baseOpenAPI}/device?m=unbindDevice`, { params: params }).then(res => res.data);
};

/**
 * @name 修改子设备
 * @param {m}  updateDevice
 * @param {token}  token
 * @param {deviceId}  deviceId
 * @param {deviceName}  deviceName设备名称(没有时不修改)
 * @param {roomId}  roomId房间Id(没有或为空时不修改)

 */
export const updateDevice = params => {
  return axios.get(`${baseOpenAPI}/device?m=updateDevice`, { params: params }).then(res => res.data);
};

/**
 * @name 添加子设备
 * @param {m}  addSubDevice
 * @param {token}  token
 * @param {uid} 设备UID
 * @param {deviceType}  设备类型
 * @param {deviceName}  deviceName设备名称
 * @param {roomId}  房间Id(没有或为空时, 服务器自动选择默认房间)
 * @param {rid} 红外Id

 */
export const addSubDevice = params => {
  return axios.get(`${baseOpenAPI}/device?m=addSubDevice`, { params: params }).then(res => res.data);
};

/**
 * @name 删除子设备
 * @param {m}  deleteSubDevice
 * @param {token}  token
 * @param {deviceId}  设备deviceId
 */

export const deleteSubDevice = params => {
  return axios.get(`${baseOpenAPI}/device?m=deleteSubDevice`, { params: params }).then(res => res.data);
};

/**
 * @name 控制设备
 * @param {m}  sendCmd
 * token
 cmd
 uid
 deviceId
 order
 value1
 value2
 value3
 value4
 freq
 pluseNum
 pluseData
 */

export const sendCmd = params => {
  return axios.get(`${baseOpenAPI}/cmd?m=sendCmd`, { params: params }).then(res => res.data);
};

/**
 * @name 获取地点名称列表
 */
export const getPlaceList = () => {
  return axios.get("https://open.bot.tmall.com/oauth/api/placelist").then(res => res.data);
};

/**
 * @name 获取设备别名
 */
export const getDevAliaslist = () => {
  return axios.get("https://open.bot.tmall.com/oauth/api/aliaslist").then(res => res.data);
};

/**
 * 查询设备列表
 */

export const getDevList = params => {
  return axios.get(`${baseOpenAPI}/aligenie?m=queryDevice`, { params: params }).then(res => res.data);
};

/**
 * 查询设备信息
 */

export const getDevInfo = params => {
  return axios.get(`${baseOpenAPI}/aligenie?m=deviceDetail`, { params: params }).then(res => res.data);
};

/**
 * 修改设备信息
 */

export const updateDevInfo = params => {
  return axios.get(`${baseOpenAPI}/aligenie`, { params: params }).then(res => res.data);
};

/**
 * 查询用户自定义频道
 * @param {object} params
 */
export const fetchChannelList = params => {
  return axios.get(`${baseOpenAPI}/channel?m=queryCustomChannel`, { params: params }).then(res => res.data);
};

/**
 * 增加自定义频道
 * @param {object} params
 */
export const addChannel = params => {
  return axios.get(`${baseOpenAPI}/channel?m=addCustomChannel`, { params: params }).then(res => res.data);
};

/**
 * 更新自定义频道
 * @param {object} params
 */
export const updateChannel = params => {
  return axios.get(`${baseOpenAPI}/channel?m=updateCustomChannel`, { params: params }).then(res => res.data);
};

/**
 * 删除自定义频道
 * @param {object} params
 */
export const deleteChannel = params => {
  return axios.get(`${baseOpenAPI}/channel?m=deleteCustomChannel`, { params: params }).then(res => res.data);
};

/**
 *  根据定位获取频道信息
 * @param {object} params
 */
export const queryChannelListByLocation = params => {
  return axios.get(`${baseOpenAPI}/channel?m=queryChannelByProvinceCity`, { params: params }).then(res => res.data);
};

/**
 *  根据定位获取频道信息
 * @param {object} params
 */
export const queryWifiControllerInfo = params => {
  return axios.get(`${baseOpenAPI}/aligenie?m=queryWifiMainDeviceDetail`, { params: params }).then(res => res.data);
};

/**
 * 获取公共频道
 * @param {object} params
 */
export const queryChannelNumberPublic = params => {
  return axios.get(`${baseOpenAPI}/channel?m=queryChannelNumberPublic`, { params: params }).then(res => res.data);
};



// WEBPACK FOOTER //
// ./src/api/index.js